import { useMemo } from "react";

import { type FlexsaveType } from "@doitintl/cmp-models";
import { useTheme } from "@mui/material/styles";
import * as Highcharts from "highcharts";
import HighchartsReact from "highcharts-react-official";

import { reportsHelpURLs } from "../../../assets/urls";
import { generateOptionsForChart } from "../../../Pages/Flexsave/Resold/Overview/Chart/SavingsChartUtils";
import { type FlexsaveData } from "../../../Pages/Flexsave/types";
import { useCurrency } from "../../hooks/useCurrency";
import { FlexsaveWidgetCard } from "../Common/FlexsaveWidgetCard";
import { MenuWidgetCard } from "../Common/MenuWidgetCard";
import { getFlexsaveWidgetTitle } from "./utils";

type Props = {
  type: FlexsaveType;
  flexSaveLink: string;
  data: FlexsaveData;
  widgetHeight: number;
};

export const FlexsaveCardEnabled = ({ type, flexSaveLink, data, widgetHeight }: Props) => {
  const theme = useTheme();
  const { customerCurrencySymbol } = useCurrency();

  const options = useMemo(
    () => generateOptionsForChart(data, theme, customerCurrencySymbol, false),
    [data, theme, customerCurrencySymbol]
  );

  const HeaderAction = <MenuWidgetCard helpUrl={reportsHelpURLs[`FLEXSAVE_${type}`]} reportPath={flexSaveLink} />;
  return (
    <FlexsaveWidgetCard
      title={getFlexsaveWidgetTitle(type)}
      subheader="Summary of your savings with Flexsave"
      headerAction={HeaderAction}
      widgetHeight={widgetHeight}
    >
      <HighchartsReact containerProps={{ style: { height: "100%" } }} highcharts={Highcharts} options={options} />
    </FlexsaveWidgetCard>
  );
};
